import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initSentry, ErrorBoundary } from './config/sentry';

// Initialize Sentry for error monitoring
initSentry();

// Handle chunk load errors (happens when user has stale JS after a deployment)
// This forces a reload to get the new assets
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('ChunkLoadError')) {
    // Prevent infinite reload loop by checking if we just reloaded
    const lastReload = sessionStorage.getItem('chunk_error_reload');
    const now = Date.now();
    if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
      sessionStorage.setItem('chunk_error_reload', now.toString());
      window.location.reload();
    }
  }
});

// Also handle unhandled promise rejections for dynamic imports
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.name === 'ChunkLoadError') {
    const lastReload = sessionStorage.getItem('chunk_error_reload');
    const now = Date.now();
    if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
      sessionStorage.setItem('chunk_error_reload', now.toString());
      window.location.reload();
    }
  }
});

// Apply dark mode from saved preferences before React renders to prevent flash
try {
  const savedPrefs = localStorage.getItem('vibary_preferences');
  if (savedPrefs) {
    const prefs = JSON.parse(savedPrefs);
    if (prefs.darkMode) {
      document.body.classList.add('dark-mode');
    }
  }
} catch (e) {
  // Ignore parsing errors
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary fallback={<div className="loading">Something went wrong. Please refresh the page.</div>}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('ServiceWorker registered:', registration.scope);
      })
      .catch((error) => {
        console.log('ServiceWorker registration failed:', error);
      });
  });
}
